<template>

  <div>
      <b-card-code title="UPS factura CSV: Descargar el de la version de 28 columnas">
        <b-row class="match-height">
          <b-col cols="10">
              <b-form-file
              v-model="csvInput"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            />
          </b-col>
          <b-col cols="2">
            <b-button
              variant="outline-primary"
              @click="addFactura"
            > Procesar
            </b-button>
          </b-col>
  
        </b-row>
      </b-card-code>
  
       <b-card-code :title="'Conflicto albaranes UPS: '+totalConflicto + ' €'">
        <div class="row" style="margin-top: 10px">
          <div class="col-5">
            <b-form-group
                label=""
                label-for="basicInput">
                <b-form-input
                id="basicInput"
                placeholder="Buscar"
                v-model="buscarAlbaran"
                />
            </b-form-group>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center mb-1">
              <span style="margin-right: 5px">Estado</span>
              <v-select
                v-model="estadoAlbaranSelect"
                :options="['Todos','Comprobado','Abonado','Sin Comprobar','Sin Abonar', 'Nota - Sin Com']"
                :clearable="false"
                placeholder="Seleccionar"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-2">
            <div class="d-flex align-items-center mb-1">
              <span style="margin-right: 5px">Cuenta</span>
              <v-select
                v-model="cuentaAlbaranSelect"
                :options="['Todas','641023272','538079880','699231916','201273180']"
                label="nombre"
                :clearable="false"
                placeholder="Seleccionar"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-2">
            <div style="text-align: right">
              <b-button
                style="margin-bottom: 10px; text-align: center"
                    variant="outline-primary"
                    @click="downloadDuplicados"
              > Descargar listado
              </b-button>
            </div>
          </div>      
        </div>
           
        <b-table
              :items="facturasDuplicadasBusqueda"
              :fields="columnasAll"
              class="table table-borderless table-prevision"
              no-border-collapse
              striped 
              ref="table"
            >
             <template #cell(_comprobado)="data">
                <span v-if="data.item.comprobado" class="span-check-1" @click="checkUpdate(data.item, 'comprobado', false)"><i class="fa-regular fa-circle-check"></i></span>
                <span v-else class="span-check-0" @click="checkUpdate(data.item, 'comprobado', true)"><i class="fa-regular fa-circle-xmark"></i></span>                          
              </template> 
  
              <template #cell(_abonado)="data">
                  <span v-if="data.item.abonado" class="span-check-1" @click="checkUpdate(data.item, 'abonado', false)"><i class="fa-regular fa-circle-check"></i></span>
                <span v-else class="span-check-0" @click="checkUpdate(data.item, 'abonado', true)"><i class="fa-regular fa-circle-xmark"></i></span>
              </template> 
  
              <template #cell(_notas)="data">
                <span class="span-edit" :class="data.item.notas.length > 0 ? 'edit-with': 'edit-empty'" @click="openModalNotas(data.item)"><i class="fa-regular fa-pen-to-square"></i></span>
              </template> 
          </b-table>
      </b-card-code>
  
      <b-card-code :title="'Conflicto diferencia de precios UPS: '+diferenciaTotal + ' €'">
         <b-row class="match-height justify-content-md-center">
              <b-col cols="2">
                  
                <b-form-group
                    label="Margen"
                    label-for="basicInput">
                    <b-form-input
                    id="basicInput"
                    placeholder="Margen a buscar"
                    v-model="margen"
                    type="number"
                    @wheel.prevent
                    />
                </b-form-group>
                 <b-button
                    style="margin-bottom: 10px; text-align: center"
                        variant="outline-primary"
                        @click="buscarMargen"
                      > <b-spinner v-if="buscandoMargen" label="Spinning"></b-spinner><span v-else>Buscar... <i class="fa-solid fa-magnifying-glass"></i></span>
                  </b-button>
              </b-col>
          </b-row>
  
          <div class="row" style="margin-top: 10px">
          <div class="col-6">
            <b-form-group
                label=""
                label-for="basicInput">
                <b-form-input
                id="basicInput"
                placeholder="Buscar"
                v-model="buscarDiferencia"
                />
            </b-form-group>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center mb-1">
              <span style="margin-right: 5px">Estado</span>
              <v-select
                v-model="estadoDiferenciaSelect"
                :options="['Todos','Comprobado','Abonado','Sin Comprobar','Sin Abonar', 'Nota - Sin Com']"
                :clearable="false"
                placeholder="Seleccionar"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center mb-1">
              <span style="margin-right: 5px">Cuenta</span>
              <v-select
                v-model="cuentaDiferenciaSelect"
                :options="['Todas','641023272','538079880','699231916','201273180']"
                label="nombre"
                :clearable="false"
                placeholder="Seleccionar"
                style="width: 100%"
              />
            </div>
          </div>          
        </div>
  
          <div style="text-align: right">
              <!--<b-button
                style="margin-bottom: 10px; text-align: center"
                    variant="outline-primary"
                  > Descargar listado
                </b-button>-->
          </div>
           
        <b-table
              :items="facturasMargenBusqueda"
              :fields="columnasMargen"
              class="table table-borderless table-prevision"
              no-border-collapse
              striped 
              ref="table"
            >
             <template #cell(_comprobado)="data">
                <span v-if="data.item.comprobado" class="span-check-1" @click="checkUpdate(data.item, 'comprobado', false)"><i class="fa-regular fa-circle-check"></i></span>
                <span v-else class="span-check-0" @click="checkUpdate(data.item, 'comprobado', true)"><i class="fa-regular fa-circle-xmark"></i></span>                          
              </template> 
  
              <template #cell(_abonado)="data">
                  <span v-if="data.item.abonado" class="span-check-1" @click="checkUpdate(data.item, 'abonado', false)"><i class="fa-regular fa-circle-check"></i></span>
                <span v-else class="span-check-0" @click="checkUpdate(data.item, 'abonado', true)"><i class="fa-regular fa-circle-xmark"></i></span>
              </template> 
  
             <template #cell(_notas)="data">
                <span class="span-edit" :class="data.item.notas.length > 0 ? 'edit-with': 'edit-empty'" @click="openModalNotas(data.item)"><i class="fa-regular fa-pen-to-square"></i></span>
              </template> 
          </b-table>
      </b-card-code>
  
       <b-modal
          id="modal-notas"
          title="Notas"
          centered
          size="lg"
          hide-footer
          >
          <b-row class="match-height justify-content-md-center">
            <textarea name="notas" cols="100" rows="7" v-model="notaSelect"></textarea>
            <b-button style="margin-top: 10px; text-align: center" variant="outline-primary" @click="guardarNota">
              Guardar <i class="fa-regular fa-floppy-disk"></i>
            </b-button>
          </b-row>
  
        </b-modal>
  </div>
  
  </template>
  
  <script>
  import axios from '@axios'
  import vSelect from 'vue-select'
  import BCardCode from '@core/components/b-card-code'
  import { BRow, BCol, BFormFile, BButton  } from 'bootstrap-vue'
  import { BTable } from 'bootstrap-vue'

  import Papa from "papaparse";
  
  
  export default {
  
    components: {
          BCardCode,
          BRow,
          BCol,
          BFormFile,
          BButton,
          vSelect,
          BTable
      },
  
    data(){
      return{
        csvInput: [],
         columnasAll: [
          {
            key: "_comprobado",
            label: "COM",
            sortable: false,
          },{
            key: "_abonado",
            label: "ABO",
            sortable: false,
          },
          {
            key: "albaran",
            label: "Tracking",
            sortable: true,
          },
          {
            key: "factura",
            label: "Factura",
            sortable: true,
          },{
            key: "cuenta",
            label: "Cuenta",
            sortable: true,
          },{
            key: "pedido",
            label: "Pedido",
            sortable: true,
          },{
            key: "total",
            label: "Precio",
            sortable: true,
          },
          {
            key: "tipo",
            label: "Tipo",
            sortable: true,
          },{
            key: "fecha",
            label: "Fecha",
            sortable: true,
          },{
            key: "_notas",
            label: "Notas",
            sortable: false,
          },],
          columnasMargen: [          
            {
            key: "_comprobado",
            label: "COM",
            sortable: false,
          },{
            key: "_abonado",
            label: "ABO",
            sortable: false,
          },
          {
            key: "albaran",
            label: "Tracking",
            sortable: true,
          },
          {
            key: "factura",
            label: "Factura",
            sortable: true,
          },{
            key: "cuenta",
            label: "Cuenta",
            sortable: true,
          },{
            key: "pedido",
            label: "Pedido",
            sortable: true,
          },{
            key: "precioSaas",
            label: "Precio SAAS",
            sortable: true,
          },
          {
            key: "total",
            label: "Precio UPS",
            sortable: true,
          },{
            key: "fecha",
            label: "Fecha",
            sortable: true,
          },{
            key: "_notas",
            label: "Notas",
            sortable: false,
          },],
          margen: 5,
          facturasDuplicadas: [],
          facturasDuplicadasBusqueda: [],
          allFacturas: [],
          totalConflicto: 0,
          totalConflictoMargen: 0,
          shippingInfo: [],
          facturasMargen: [],
          facturasMargenBusqueda: [],
          diferenciaTotal: 0,
          buscandoMargen: false,
          notaSelect: "",
          idSelect: -1,
          estadoAlbaranSelect: 'Sin Comprobar',
          cuentaAlbaranSelect: 'Todas',
          buscarAlbaran: '',
          estadoDiferenciaSelect: 'Sin Comprobar',
          cuentaDiferenciaSelect: 'Todas',
          buscarDiferencia: ''        
      }
    },
    methods:{
      buscarDuplicados(){
          this.facturasDuplicadas = [];
  
          const duplicadosMap = {};
  
          this.allFacturas.forEach(item => {
              const clave = `${item.albaran}-${item.tipo}`;
  
              // Verificar si ya existe en el mapa
              if (!duplicadosMap[clave]) {
                  duplicadosMap[clave] = [];
              }
  
              duplicadosMap[clave].push(item);
          });
  
          // Filtrar solo los elementos que tienen duplicados
          this.facturasDuplicadas = Object.values(duplicadosMap)
              .filter(duplicados => duplicados.length > 1)
              .flat();
  
          /*this.allFacturas.forEach(item => {
              const duplicados = this.allFacturas.filter(itemDuplicado =>
                  item.id !== itemDuplicado.id &&
                  item.albaran === itemDuplicado.albaran &&
                  item.tipo === itemDuplicado.tipo
              );
              this.facturasDuplicadas.push(...duplicados);
          });*/
  
          this.facturasDuplicadas.forEach(item => {
              this.totalConflicto += parseFloat(item.total);
          });
  
          this.facturasDuplicadas.sort((a, b) => (a.albaran > b.albaran) ? 1 : -1);   
  
          this.totalConflicto = this.totalConflicto.toFixed(2);
  
          this.buscandoAlbaran();
  
      },
      buscarMargen(){
        this.buscandoMargen = true;
  
        setTimeout(() => {        
          this.diferenciaTotal = 0;
          this.facturasMargen = [];        
  
          const facturasIndexadas = {};
          this.allFacturas.forEach(factura => {
          
              facturasIndexadas[factura.pedido] = facturasIndexadas[factura.pedido] || [];
              facturasIndexadas[factura.pedido].push(factura);
            
          });
  
          this.shippingInfo.forEach(saas => {
            //const facturasEncontradas = this.allFacturas.filter(factura => factura.pedido === saas.order && factura.tipo == "Carga Freight");
            const facturasEncontradas = facturasIndexadas[saas.order] || [];
  
            let totalFedex = 0;
  
            if (facturasEncontradas.length > 0) {
              facturasEncontradas.forEach(fedex => {
                totalFedex += fedex.total;
              });
            }
  
            let diferencia = totalFedex - saas.service - this.margen;
  
            if(diferencia > 0 && totalFedex != 0)
            {
              this.diferenciaTotal += (totalFedex - saas.service);
  
              facturasEncontradas.forEach(fedex => {
                let newFedex = fedex;
                newFedex.precioSaas = saas.service;
                this.facturasMargen.push(newFedex);
              });
  
            }
          });
  
          this.diferenciaTotal = Math.round(this.diferenciaTotal * 100) / 100;
  
          this.facturasMargen.sort((a, b) => (a.pedido > b.pedido) ? 1 : -1);
  
          this.buscandoMargen = false;
  
          this.buscandoDiferencia();
        }, 200);
  
      },
      loadItems(){
  
        axios.post("/uso", {seccion:"ups"});
  
        axios
          .get("/ups/factura")
          .then(response => {
              return response.data;
          })
          .then(res => {
              this.allFacturas = res;
  
              let orders = [];
  
              this.allFacturas.forEach(item => {
                orders.push(item.pedido)
                
              });
  
              let uniqueOrders = [...new Set(orders)];
  
              axios
                .post("/ups/shipping", uniqueOrders)
                .then(response => {
                    return response.data;
                })
                .then(res => {

                  this.shippingInfo = res.map(item => {
                      const service = item.full_data.service;
                      const precio = service ? parseFloat(service.match(/\d+(\.\d+)?/)?.[0]) : -1;
  
                      return {
                          order: item.order_num,
                          service: precio
                      };
                  }).reduce((accumulated, current) => {
                      const existingOrder = accumulated.find(entry => entry.order === current.order);
  
                      if (existingOrder) {
                          existingOrder.service += current.service;
                          existingOrder.service = parseFloat(existingOrder.service).toFixed(2);
                      } else {
                          accumulated.push({ order: current.order, service: current.service });
                      }
  
                      return accumulated;
                  }, []);
                });
               
  
              //console.log(uniqueOrders);
  
  
              this.buscarDuplicados();
            //console.log(res);
          });
          
        
  
        /*axios
          .post("/fedex/shipping", orders)
          .then(response => {
              return response.data;
          })
          .then(res => {
              console.log(res);
          });*/
  
      },
      addFactura(){
  
        var reader = new FileReader();
        var self = this;
        reader.onload = (e) => {

          let csvText = reader.result;

          // Usamos PapaParse para convertir el CSV a un array de objetos
          let parsedData = Papa.parse(csvText, {
            delimiter: ",", // Separador de columnas
            quoteChar: '"', // Maneja comillas dobles
            header: false, // No tiene encabezados
            skipEmptyLines: true,
          }).data;

          if (parsedData.length > 0)
            parsedData.shift();
  
          let info = { lineas: parsedData}

          axios
            .post("/ups/factura", info)
            .then(response => {
                return response.data;
            })
            .then(res => {

              console.log(res);
  
              if(res.msg=="Facturas ups introducidas")
              {
                this.$bvToast.toast(`Se ha subido el archivo correctamente`, {
                  title: 'Fedex factura',
                    variant: 'success',
                    solid: true,
                  })
              }
              else if (res.msg=="No se han encontrado datos nuevos."){
                this.$bvToast.toast(`No se han encontrado datos nuevos.`, {
                  title: 'UPS factura',
                    variant: 'danger',
                    solid: true,
                  })
              }

              this.loadItems();
  
            }).catch(e => {
              this.$bvToast.toast(`El formato no es correcto.`, {
                  title: 'Fedex factura',
                    variant: 'danger',
                    solid: true,
                  })
          })
  
          //self.res = data;
        }
  
          reader.readAsText(this.csvInput);
      },
      downloadDuplicados(){
          let csv = "Albaran;Factura;Pedido;Precio;Fecha;Tipo\n";
  
          this.facturasDuplicadas.forEach(item => {
              csv += `${item.albaran};${item.factura};${item.pedido};${item.total};${item.fecha};${item.tipo}\n`;
          });
  
          //console.log("this.facturasDuplicadas.length: " + this.facturasDuplicadas.length);
  
          var encodedUri = encodeURI(csv);
  
          //console.log(encodedUri);
          var link = document.createElement("a");
          link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
          link.setAttribute("download","duplicados.csv");
          document.body.appendChild(link); 
          link.click();
      },
      checkUpdate(data, seccion, valor){
        let dataSend = {
          campo: seccion,
          valor,
          id: data.id
        };
  
         axios
            .put("/ups/factura", dataSend)
            .then(response => {
                return response.data;
            })
            .then(res => {
  
              const facturaEncontrada = this.facturasDuplicadas.find(item => item.id === data.id);
              if(facturaEncontrada != null)
              {
                if(seccion=="comprobado")
                  facturaEncontrada.comprobado = valor;
                else if(seccion=="abonado")
                  facturaEncontrada.abonado = valor;
              }
  
              const facturaEncontradaBusqueda = this.facturasDuplicadasBusqueda.find(item => item.id === data.id);
              if(facturaEncontradaBusqueda != null)
              {
                if(seccion=="comprobado")
                  facturaEncontradaBusqueda.comprobado = valor;
                else if(seccion=="abonado")
                  facturaEncontradaBusqueda.abonado = valor;
              }
  
              const facturaEncontradaMargen = this.facturasMargen.find(item => item.id === data.id);
              if(facturaEncontradaMargen != null)
              {
                if(seccion=="comprobado")
                  facturaEncontradaMargen.comprobado = valor;
                else if(seccion=="abonado")
                  facturaEncontradaMargen.abonado = valor;
              }
  
              const facturaEncontradaMargenBusqueda = this.facturasMargenBusqueda.find(item => item.id === data.id);
              if(facturaEncontradaMargenBusqueda != null)
              {
                if(seccion=="comprobado")
                  facturaEncontradaMargenBusqueda.comprobado = valor;
                else if(seccion=="abonado")
                  facturaEncontradaMargenBusqueda.abonado = valor;
              }
  
            });
      },
      openModalNotas(data){
  
        this.notaSelect = data.notas;
        this.idSelect = data.id;
  
        this.$bvModal.show('modal-notas');
      },
      guardarNota(){
  
        let dataSend = {
          valor: this.notaSelect,
          id: this.idSelect
        };
  
         axios
            .put("/ups/nota", dataSend)
            .then(response => {
                return response.data;
            })
            .then(res => {
  
              let facturaEncontrada = this.facturasDuplicadas.find(item => item.id == this.idSelect);
              if(facturaEncontrada != null)
                facturaEncontrada.notas = this.notaSelect;
  
              let facturaEncontradaBusqueda = this.facturasDuplicadasBusqueda.find(item => item.id == this.idSelect);
              if(facturaEncontradaBusqueda != null)
                facturaEncontradaBusqueda.notas = this.notaSelect;
              
              let facturaEncontradaMargen = this.facturasMargen.find(item => item.id == this.idSelect);
              if(facturaEncontradaMargen != null)
                facturaEncontradaMargen.notas = this.notaSelect;
  
              let facturaEncontradaMargenBusqueda = this.facturasMargenBusqueda.find(item => item.id == this.idSelect);        
              if(facturaEncontradaMargenBusqueda != null)
                facturaEncontradaMargenBusqueda.notas = this.notaSelect;
  
              this.$bvModal.hide('modal-notas');
  
            });
  
      },
      buscandoAlbaran(items = this.facturasDuplicadas){
  
        let auxSorting = JSON.parse(JSON.stringify(items));
  
        items = auxSorting;
  
        this.facturasDuplicadasBusqueda = [];
  
        this.facturasDuplicadasBusqueda = items.filter(factura => {
          const estadoCondicion = 
            this.estadoAlbaranSelect === "Todos" ||
            (this.estadoAlbaranSelect === "Comprobado" && factura.comprobado === 1) ||
            (this.estadoAlbaranSelect === "Abonado" && factura.abonado === 1) ||
            (this.estadoAlbaranSelect === "Sin Comprobar" && factura.comprobado === 0 ) ||
            (this.estadoAlbaranSelect === "Sin Abonar" && factura.abonado === 0)||
            (this.estadoAlbaranSelect === "Nota - Sin Com" && factura.comprobado === 0 && factura.notas.length > 0 );    
  
            //Nota - Sin Com
  
          const cuentaCondicion = this.cuentaAlbaranSelect === 'Todas' || this.cuentaAlbaranSelect === factura.cuenta;
  
          const textoCondicion = factura.albaran.toLowerCase().includes(this.buscarAlbaran.toLowerCase()) || factura.factura.toLowerCase().includes(this.buscarAlbaran.toLowerCase())
          || factura.pedido.toLowerCase().includes(this.buscarAlbaran.toLowerCase()) || factura.notas.toLowerCase().includes(this.buscarAlbaran.toLowerCase()) ;
  
          if(this.buscarAlbaran != '')
          {
            return textoCondicion;
          }else
          {
            return estadoCondicion && cuentaCondicion
  
          }
          //return (estadoCondicion && cuentaCondicion) || (textoCondicion && this.buscarAlbaran != '');
        });
        
      },
      buscandoDiferencia(items = this.facturasMargen){
  
        let auxSorting = JSON.parse(JSON.stringify(items));
  
        items = auxSorting;
  
        this.facturasMargenBusqueda = [];
  
        this.facturasMargenBusqueda = items.filter(factura => {
          const estadoCondicion = 
            this.estadoDiferenciaSelect === "Todos" ||
            (this.estadoDiferenciaSelect === "Comprobado" && factura.comprobado === 1) ||
            (this.estadoDiferenciaSelect === "Abonado" && factura.abonado === 1) ||
            (this.estadoDiferenciaSelect === "Sin Comprobar" && factura.comprobado === 0 ) ||
            (this.estadoDiferenciaSelect === "Sin Abonar" && factura.abonado === 0) ||
            (this.estadoDiferenciaSelect === "Nota - Sin Com" && factura.comprobado === 0 && factura.notas.length > 0 );    
          
          const cuentaCondicion = this.cuentaDiferenciaSelect === 'Todas' || this.cuentaDiferenciaSelect === factura.cuenta;
  
          const textoCondicion = factura.albaran.toLowerCase().includes(this.buscarDiferencia.toLowerCase()) || factura.factura.toLowerCase().includes(this.buscarDiferencia.toLowerCase())
          || factura.pedido.toLowerCase().includes(this.buscarDiferencia.toLowerCase()) || factura.notas.toLowerCase().includes(this.buscarDiferencia.toLowerCase()) ;
  
          if(this.buscarDiferencia != '')
          {
            return textoCondicion;
          }else
          {
            return estadoCondicion && cuentaCondicion
  
          }
  
          //return (estadoCondicion && cuentaCondicion) || (textoCondicion && this.buscarDiferencia != '');
        });
  
        }
    },
    mounted() {    
        this.loadItems();
    },
    watch: {
      buscarAlbaran(){
        this.buscandoAlbaran();
      },
      estadoAlbaranSelect(){
        this.buscandoAlbaran();
      },
      cuentaAlbaranSelect(){
        this.buscandoAlbaran();
      },
      buscarDiferencia(){
        this.buscandoDiferencia();
      },
      estadoDiferenciaSelect(){
        this.buscandoDiferencia();
      },
      cuentaDiferenciaSelect(){
        this.buscandoDiferencia();
      }
    }
  
  }
  </script>
  
  <style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';
  
  .button_ejemplos{
    text-align: center;
    width: 100px;
    border: 1px solid black;
    border-radius: 10px; 
    padding: 5px;
    margin-bottom: 10px;
    color: black; 
    margin-top: 10px;
  }
  
  .button_ejemplos:hover{
    cursor: pointer;
  }
  
  .button_plantilla{
    margin-bottom: 0px;
  }
  
  .button_plantilla:hover{
    cursor: pointer;
  }
  
  .button-descargar:hover{
      cursor: pointer;
  }
  
  .span-check-0:hover{
    cursor: pointer;
  }
  
  .span-check-1:hover{
    cursor: pointer;
  }
  
  .span-check-0{
    font-size: 20px;
    color: red;
  }
  
  .span-check-1{
    font-size: 20px;
    color: green;
  }
  
  .span-edit:hover{
    cursor: pointer;
  }
  
  .span-edit{
    font-size: 20px;
  }
  
  .edit-with{
    color:green;
  }
  
  </style>